export default "__VITE_ASSET__45e4892e__"